var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.792,
    height: 26.581,
    viewBox: "0 0 27.792 26.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Instagram-Account-Icon-03bnfc3",
    d: "M25.573,24.968V23.275a5.037,5.037,0,0,0-5.028-5.027H6.247a5.038,5.038,0,0,0-5.036,5.027l.013,1.69a.613.613,0,0,1-.606.616.609.609,0,0,1-.61-.608L0,23.277a6.252,6.252,0,0,1,6.247-6.242h14.3a6.252,6.252,0,0,1,6.247,6.24v1.693a.62.62,0,0,1-.614.613A.613.613,0,0,1,25.573,24.968ZM6.083,7.3a7.305,7.305,0,1,1,7.309,7.3A7.3,7.3,0,0,1,6.083,7.3ZM7.3,7.3a6.087,6.087,0,1,0,6.09-6.08A6.093,6.093,0,0,0,7.3,7.3Z",
    transform: "translate(0.5 0.5)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.3707aea17a6bb13c42f758482829e02d.svg";
export { ForwardRef as ReactComponent };